module.exports = __webpack_public_path__ + "static/pic15-42fd2e2da76940faf7d11e58229e2b05.png";